/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Your_Existing_Stripe_AccoInputs */

const en_link_your_existing_stripe_acco = /** @type {(inputs: Link_Your_Existing_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link your existing Stripe account or create a new one in less than 3 minutes.`)
};

const es_link_your_existing_stripe_acco = /** @type {(inputs: Link_Your_Existing_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincula tu cuenta de Stripe existente o crea una nueva en menos de 3 minutos.`)
};

const fr_link_your_existing_stripe_acco = /** @type {(inputs: Link_Your_Existing_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liez votre compte Stripe existant ou créez-en un nouveau en moins de 3 minutes.`)
};

const de_link_your_existing_stripe_acco = /** @type {(inputs: Link_Your_Existing_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpfe dein bestehendes Stripe-Konto oder erstelle in weniger als 3 Minuten ein neues.`)
};

const ja_link_your_existing_stripe_acco = /** @type {(inputs: Link_Your_Existing_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既存のStripeアカウントをリンクするか、3分以内で新しいアカウントを作成します。`)
};

const zh_link_your_existing_stripe_acco = /** @type {(inputs: Link_Your_Existing_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接您现有的 Stripe 账号或在 3 分钟内创建一个新账号。`)
};

const ar_link_your_existing_stripe_acco = /** @type {(inputs: Link_Your_Existing_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اربط حساب Stripe الحالي أو أنشئ حساباً جديداً في أقل من 3 دقائق.`)
};

const id_link_your_existing_stripe_acco = /** @type {(inputs: Link_Your_Existing_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tautkan akun Stripe Anda yang sudah ada atau buat yang baru dalam kurang dari 3 menit.`)
};

const it_link_your_existing_stripe_acco = /** @type {(inputs: Link_Your_Existing_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collega il tuo account Stripe esistente o creane uno nuovo in meno di 3 minuti.`)
};

const ru_link_your_existing_stripe_acco = /** @type {(inputs: Link_Your_Existing_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привяжите существующий аккаунт Stripe или создайте новый менее чем за 3 минуты.`)
};

const pt_link_your_existing_stripe_acco = /** @type {(inputs: Link_Your_Existing_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vincule sua conta existente do Stripe ou crie uma nova em menos de 3 minutos.`)
};

const ko_link_your_existing_stripe_acco = /** @type {(inputs: Link_Your_Existing_Stripe_AccoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기존 Stripe 계정을 연결하거나 3분 안에 새 계정을 만드세요.`)
};

/**
* | output |
* | --- |
* | "Link your existing Stripe account or create a new one in less than 3 minutes." |
*
* @param {Link_Your_Existing_Stripe_AccoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_your_existing_stripe_acco = /** @type {((inputs?: Link_Your_Existing_Stripe_AccoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Your_Existing_Stripe_AccoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_your_existing_stripe_acco(inputs)
	if (locale === "es") return es_link_your_existing_stripe_acco(inputs)
	if (locale === "fr") return fr_link_your_existing_stripe_acco(inputs)
	if (locale === "de") return de_link_your_existing_stripe_acco(inputs)
	if (locale === "ja") return ja_link_your_existing_stripe_acco(inputs)
	if (locale === "zh") return zh_link_your_existing_stripe_acco(inputs)
	if (locale === "ar") return ar_link_your_existing_stripe_acco(inputs)
	if (locale === "id") return id_link_your_existing_stripe_acco(inputs)
	if (locale === "it") return it_link_your_existing_stripe_acco(inputs)
	if (locale === "ru") return ru_link_your_existing_stripe_acco(inputs)
	if (locale === "pt") return pt_link_your_existing_stripe_acco(inputs)
	return ko_link_your_existing_stripe_acco(inputs)
});